<!-- <div	[ngClass]="{'bg-loading':vistaLoading == 'normal'}" *ngIf="loading"></div> -->
<div class="progress" *ngIf="loading">
      <div class="indeterminate"></div>
</div>
